export const MESSAGE_SUCCESS = {
  addDepartment: "Thêm khoa thành công",
  updateDepartment: "Sửa khoa thành công",
  deleteDepartment: "Xóa khoa thành công",
  addRoom: "Thêm phòng thành công",
  updateRoom: "Sửa phòng thành công",
  deleteRoom: "Xóa phòng thành công",
}
